var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "role-list" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("角色权限")]),
      _c(
        "div",
        [
          _vm.rolesCode === "ROLE_ADMIN"
            ? _c(
                "el-form",
                { staticClass: "search-form", attrs: { inline: true } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 19 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "输入角色名称",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.queryList("search")
                                },
                              },
                              model: {
                                value: _vm.searchName,
                                callback: function ($$v) {
                                  _vm.searchName = $$v
                                },
                                expression: "searchName",
                              },
                            },
                            [
                              _c("el-button", {
                                staticClass: "search-icon",
                                attrs: { slot: "append", icon: "icon-sousuo" },
                                on: {
                                  click: function ($event) {
                                    return _vm.queryList("search")
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "button-container",
                          attrs: { type: "primary", size: "14" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增角色")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            size: "medium",
            "header-cell-style": { background: "#F5F6F7" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "角色" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.roleName || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.rolesCode === "ROLE_ADMIN"
            ? _c("el-table-column", {
                attrs: { label: "角色标识" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(scope.row.roleCode || "-") +
                              "\n      "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2182361513
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "操作权限说明" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.roleDesc || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.rolesCode === "ROLE_ADMIN" || _vm.rolesCode === "PLATFORM_ADMIN"
            ? _c("el-table-column", {
                attrs: { fixed: "right", label: "菜单权限" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.rolesCode === "ROLE_ADMIN"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "operate" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm.rolesCode === "ROLE_ADMIN"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "operate" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(scope.row.roleId)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "operate" },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePermission(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("权限编辑\n        ")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3394812058
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.tableData.length > 10
        ? _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.status === "add" ? "新增角色" : "编辑角色",
            visible: _vm.dialogVisible,
            width: "628px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "define-form",
              attrs: {
                model: _vm.addFormData,
                rules: _vm.rules,
                "label-width": "110px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "角色", prop: "roleName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入角色", clearable: "" },
                    model: {
                      value: _vm.addFormData.roleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "roleName", $$v)
                      },
                      expression: "addFormData.roleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "角色标识", prop: "roleCode" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入角色标识", clearable: "" },
                    model: {
                      value: _vm.addFormData.roleCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "roleCode", $$v)
                      },
                      expression: "addFormData.roleCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "操作权限说明", prop: "roleDesc" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入操作权限说明", clearable: "" },
                    model: {
                      value: _vm.addFormData.roleDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "roleDesc", $$v)
                      },
                      expression: "addFormData.roleDesc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "14" }, on: { click: _vm.handleClose } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "14" },
                  on: { click: _vm.onsubmit },
                },
                [_vm._v("确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogPermissionVisible,
            "close-on-click-modal": false,
            width: "628px",
            title: "分配权限",
            "custom-class": "menu-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPermissionVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-main-tree" },
            [
              _c("el-tree", {
                ref: "menuTree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.treeData,
                  "default-checked-keys": _vm.checkedKeys,
                  "check-strictly": false,
                  props: _vm.defaultProps,
                  "filter-node-method": _vm.filterNode,
                  "node-key": "id",
                  "highlight-current": "",
                  "show-checkbox": "",
                  "default-expand-all": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.updatePermession(_vm.roleId)
                    },
                  },
                },
                [_vm._v("更 新\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.cancal()
                    },
                  },
                },
                [_vm._v("取消\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }